/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Fragment, useMemo, useRef, useState } from 'react';
import { Button, Table, Col } from 'react-bootstrap';
import { PROJECT_BASENAME } from 'constants/env';
import { transformArrayWithId } from 'util/transformHelpers';
import searchIcon from 'assets/img/buscar.png';
import iconGift from 'assets/img/iconregalo.svg'
// eslint-disable-next-line no-unused-vars
import { CustomIcon } from 'components';
import { setLoginRedirect , setLoginRedirectSSO } from 'util/navigation';
import { useStorage64 ,useWindowSize} from 'hooks';
import TableSearchModal from 'components/gifts-table/TableSearchModal';
import { useEffect } from 'react';
import styles from './styles.module.scss';


const getCellClassNames = (
  { align = 'center', variant = '', weight = '' , textcolor = '#212529'},
  notVariant = false
) => {
  const cellAlign = `text-${align}`;
  const cellVariant = `${variant && !notVariant ? `text-${variant}` : ''}`;
  const cellWeight = ` ${weight ? `font-weight-${weight}` : ''}`;

  const cellClassName = `${cellAlign} ${cellVariant} ${cellWeight}`;
  return cellClassName;
};

const CellRendererGray = (field1, field2) => (
  <td style={{ verticalAlign: 'middle' }}>
    <b>{field1}</b>
    <p className="d-block font-weight-normal">{field2 ? ` #${field2}` : field2}</p>
  </td>
);

const CellRendererRed = (field1, field2) => (
  <td style={{ verticalAlign: 'middle' }}>
    <b>{field1}</b>
    <p className="d-block font-weight-normal">{field2 ? ` #${field2}` : field2}</p>
  </td>
);

const CellRendererButton = ({
  children,
  onClick,
  stopParentPropagation,
  ...rest
}) => {
  const handleClick = (e) => {
    if (stopParentPropagation) stopParentPropagation();
    onClick(e);
  };
  // console.log('children', children);
  return (
    <td>
      <Button
          block
          variant="primary"
          type="button"
          size="sm"
          className="primaryButton"
          onClick={onClick}
          {...rest}
      >
        {children}
      </Button>
    </td>
  );
};

export const Cell = ({
  column,
  item,
  isBody = false,
  stopParentPropagation,
  queryAgentId,
  queryTableId,
  queryAgentToken,
}) => {
  const handleClick = (e) => {
    if (stopParentPropagation) {
      stopParentPropagation();
    }
    if (column.onClickDetail) {
      column.onClickDetail(e, item);
    }
  };
  const withAdmin = `?agent_staff=${queryAgentId}&agent_table_id=${queryTableId}&agent_token=${queryAgentToken}`;
  const field = item[column.field];
  return (
    <>
      <td width={column?.width || ''}
        className={`${getCellClassNames(column)} ${
          column.longField ? `${styles.longCell} text-overflow-ellipsis` : ''
        }`}
        style={{ verticalAlign: 'middle', padding: '0.5rem', color: column.textcolor  }}
      >
        {column.longField ? (
          <div>
            <p className="text-overflow-ellipsis">{field}</p>

            {column.showDetail && (
              <p className="text-primary d-inline-block" onClick={handleClick}>
                Ver
              </p>
            )}
          </div>
        ) : (
          field
        )}
        {column.showDetail && isBody && !column.longField && (
          <p className="pointer text-primary text-center mt-3 mb-0">
            <a
              href={`${window.location.origin}/${PROJECT_BASENAME.replace(
                /\//g,
                ''
              )}/regalos-recibidos/${item.id}/details${
                queryAgentId ? withAdmin : ''
              }`}
            >
              Ver detalle
            </a>
          </p>
        )}
      </td>
    </>
  );
};

export const HeadCell = ({ column }) => (
  <td className={`${getCellClassNames(column, true)}`}>
    {column.singleMobileCell ? (
      <div className="py-3">{column.label}</div>
    ) : (
      column.label
    )}
  </td>
);

const BodyRow = ({
  item,
  columns,
  clickableRow = false,
  onRowClick,
  show,
  queryAgentId,
  queryTableId,
  queryAgentToken,
  ...props
}) => {

  const rowRef = useRef({ stopPropagation: false });

  const handleClick = () => {
    if (!rowRef.current.stopPropagation) {
      if (onRowClick) onRowClick(item);
    } else {
      rowRef.current.stopPropagation = false;
    }
  };

  const handleStopPropagation = () => {
    if (rowRef.current && !rowRef?.current?.stopPropagation) {
      rowRef.current.stopPropagation = true;
    }
  };
  const withAdmin = `?agent_staff=${queryAgentId}&agent_table_id=${queryTableId}&agent_token=${queryAgentToken}`;
  return (
    <tr
      onClick={handleClick}
    >
      {columns.map((column) => {
        const columnRenderer = column.renderer || column.bodyRenderer;
        return (
          <Fragment key={column.id}>
            {column.showDetailLink && (
                <p className="pointer text-primary text-center mt-3 mb-0">
                  <a
                    href={`${window.location.origin}/${PROJECT_BASENAME.replace(
                      /\//g,
                      ''
                    )}/regalos-recibidos/${item.id}/detailsv2${
                      queryAgentId ? withAdmin : ''
                    }`}
                  >
                    Ver detalle
                  </a>
                </p>
              )}
            {columnRenderer ? (
              columnRenderer(
                {
                  ...item,
                  isBody: true,
                  rowRef,
                  stopParentPropagation: handleStopPropagation,
                  ...props,
                },
                column,
                item,
                show
              )
            ) : (
              <Cell
                id={column.id}
                column={column}
                item={item}
                isBody
                rowRef={rowRef}
                queryAgentId={queryAgentId}
                queryTableId={queryTableId}
                queryAgentToken={queryAgentToken}
                {...props}
              />
            )}
          </Fragment>
        );
      })}
    </tr>
  );
};

const HeadRow = ({ columns }) => (
  <>
    {columns.map((column) => (
      <Fragment key={column.id}>
        {column.renderer && !column.noRenderer ? (
          column.renderer(
            { ...column, ...column.label, isHeader: true },
            column
          )
        ) : (
          <HeadCell column={column} />
        )}
      </Fragment>
    ))}
  </>
);

const TableList = ({
  columns,
  data,
  className = '',
  notResults,
  notResultsActive = false,
  dataType='regalos',
  queryAgentId,
  queryTableId,
  queryAgentToken,
  messageBold,
  ...props
}) => {
  const { variant = '', message = 'Aún no tienes mesas de regalos creadas' } =
    props;
  const columnsWithId = useMemo(() => transformArrayWithId(columns), [columns]);
  // console.log('columnsWithId',columnsWithId);
  const [isLogged] = useStorage64('session_token', '');
  const isLoggedIn = !!(isLogged && isLogged.length);
  const [showSearch, setShowSearch] = useState(false);
  const giftTablesTotalbypass = localStorage.getItem('giftTablesTotalbypass');
  const [,{isMobile}] = useWindowSize()
  // console.log('giftTablesTotalbypass___ por byspass',giftTablesTotalbypass);

  // console.log('data',data);

  return (
      <div className="overflow-auto tableStylesCustom">
        {data.length > 0 ? (
            
            <Table table borderless striped size="sm" responsive="sm" style={{ verticalAlign: 'middle' }}>
              <thead className="thead-light">
              {columnsWithId.length > 0 && columnsWithId[0].label.evento === 'Mesa de regalos' ? (
                <tr>
                  <th colSpan={columns.length} className="text-center bold">
                    <strong>Mesa de regalo</strong>
                  </th>
                </tr>
              ) : (
                dataType==='wallet-transactions' ? (
                  <tr>
                  <th colSpan={columns.length} className="text-center bold">
                    <strong>Detalle de movimientos</strong>
                  </th>
                </tr>
                ) : (
                  <>
                    <HeadRow className="text-center bold" columns={columnsWithId} />
                  </>
                )
              )}
              </thead>
              <tbody style={{ verticalAlign: 'middle' }}>
                {data.map((item) => (
                    <BodyRow
                        key={item.id}
                        item={item}
                        columns={columnsWithId}
                        queryAgentId={queryAgentId}
                        queryTableId={queryTableId}
                        queryAgentToken={queryAgentToken}
                        {...props}
                    />
                ))}
              </tbody>
            </Table>
        ) : (
          <>
            {notResultsActive
              ?
                notResults
                  ?
                    <div className={`${styles.tablecontainer} tablecontainer`}>
                      <div className={styles.ajusteIcono}>
                        <img src={isMobile ? iconGift : searchIcon} alt=""/>
                        <p className="text-center mt-5">{message} <strong>{messageBold}</strong></p>
                      </div>
                    </div>
                  : null
                : 
                <div className={`${styles.tablecontainer} tablecontainer`}>
                  <div className={styles.ajusteIcono}>
                    <img src={isMobile ? iconGift : searchIcon} alt=""/>
                    <p className="text-center mt-5">{message} <strong>{messageBold}</strong></p>
                  </div>
                </div>
            }
            {giftTablesTotalbypass === '0' ? (
              <div>
                <Col className={styles.buttoncontainer}>
                  <a className="link-button center" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
                    <Button variant="primary" className={`border-0 px-4 ${styles.mobileButton}`}>
                      Crear mi mesa de regalos
                    </Button>
                  </a>
                </Col>
                <Col className={styles.buttoncontainer}>
                  {showSearch && (
                    <TableSearchModal
                      show={showSearch}
                      onClose={() => setShowSearch(false)}
                    />
                  )}
                  <Button variant="secundary" onClick={() => setShowSearch(true)}>Buscar mesa</Button>
                </Col>
              </div>
            ) : null}
          </>
        )}
      </div>

  );
};

export { TableList, CellRendererButton, CellRendererGray, CellRendererRed };
